import 'css-chunksrc/client/pages/zonesPage/zonesPage/zone/averageWeather/styles.scss';export default {
  "weatherReport": "_weatherReport_1mio4_1",
  "iconBox": "_iconBox_1mio4_9",
  "icon": "_icon_1mio4_9",
  "averageScore": "_averageScore_1mio4_21"
};